module.exports = __webpack_public_path__ + "media/images/landing/en/main@2x-1c7469ff571ed88078e993d66a3f4c72.png";